
import { Component, Vue, Watch } from "vue-property-decorator";
import {
  IContainerTypesModel,
  IDefaultShippingOrderModel,
  ITypeModel,
  IUserModel,
} from "@/api/types";
import Pagination from "@/components/Pagination/index.vue";
import { Form, Message } from "element-ui";
import {
  batchDeleteShippingOrders,
  confirmPutShipping,
  createShippingOrderContainerType,
  deleteShippingOrderContainerType,
  getShippingOrderStatus,
  searchShippingOrder, updateBillLadingCode, updateRemark,
  updateShippingOrderContainerType,
} from "@/api/shipping-order";
import { getContainerType } from "@/api/container-type";
import { getUsersByJobPosition } from "@/api/users";
import { Moment } from "moment";
import { ShippingOrderModel } from "@/model/shipping-order";
import CreateShippingOrderDialog from "@/views/customs-management/component/CreateShippingOrderDialog.vue";
import ShippingOrderDetailDialog from "@/views/customs-management/component/ShippingOrderDetailDialog.vue";

@Component({
  name: "ShippingOrderManagement",
  components: {
    CreateShippingOrderDialog,
    ShippingOrderDetailDialog,
    Pagination,
  },
})
export default class extends Vue {
  private tableKey = 0;
  private show_remark= false;
  private remark = '';
  private remark_max_length = 512;
  private billLadingCode = "";
  private containerTypeOptionsList: ITypeModel[] = [];
  public shippingOrder: IDefaultShippingOrderModel[] = [];
  private sellerList: IUserModel[] = [];
  private actionName = {
    create: "新增",
    createContainerType: "新增柜型",
    editContainerType: "编辑柜型",
    confirmPutShipping: "确认放舱",
  };
  public shippingOrderStatusList: [{ name: string; desc: string }] = [
    { name: null, desc: null },
  ];
  private rule = {
    billLadingCode: [
      { required: true, message: "海运提单号不能为空", trigger: "blur" },
    ],
  };

  private JobPositionType = {
    seller: "seller",
    purchaser: "purchaser",
    logisticsClerk: "logistics-clerk",
  };
  private cascadeProps = {
    multiple: true,
    emitPath: false,
    value: "id",
    label: "name",
  };
  private total = 0;
  private listLoading = true;
  private selectedRow: ShippingOrderModel = new ShippingOrderModel();

  //对话框的一个状态
  private dialogStatus = "";
  private dialogFormVisible = false;
  private containerTypeVisible = false;
  private confirmPutShippingVisible = false;

  public payload = {} as WriteShippingOrderInput;

  configuredContainerTypes = [{ id: null, name: null, value: null }];
  private listParam = {
    shippingCode: null,
    status: null,
    startDate: null,
    endDate: null,
    pageNumber: 1,
    pageSize: 20,
    dateRange: null,
    customerKeyword: "",
    saleName: "",
  };

  created() {
    if(this.$route.query.code) {
      this.listParam.shippingCode = this.$route.query.code;
    }
    this.initContainerTypeList();
    this.initSellerList();
    this.getList();
    this.initShippingOrderStatusList();
  }

  activated() {
    this.initContainerTypeList();
    this.initSellerList();
    this.getList();
    this.initShippingOrderStatusList();
  }

  private getHiddenColumns() {
    if (
      this.$route.meta.buttonCodes &&
      Array.isArray(this.$route.meta.buttonCodes)
    ) {
      return this.$route.meta.buttonCodes.includes("actionColumns");
    }
  }

  private handleFilter() {
    this.listParam.pageNumber = 1;
    this.getList();
  }

  private async initShippingOrderStatusList() {
    const { status }: any = await getShippingOrderStatus();
    this.shippingOrderStatusList = status;
  }

  private async getList() {
    const params = { ...this.listParam };
    if (params.dateRange?.length > 0) {
      params.startDate = this.listParam.dateRange[0];
      params.endDate = this.listParam.dateRange[1];
      params.dateRange = null;
    }
    if (params.startDate > params.endDate) {
      Message({
        message: "结束日期必须大于起始日期",
        type: "error",
        duration: 2 * 1000,
      });
      return;
    }
    this.listLoading = false;
    const { total, content }: any = await searchShippingOrder(params);
    this.total = total;
    this.shippingOrder = content;
    setTimeout(() => {
      this.listLoading = false;
    }, 0.3 * 1000);
  }

  private async deleteContainerType(containerTypeId: string) {
    await deleteShippingOrderContainerType(containerTypeId);
    this.selectedRow.containerTypeList =
      this.selectedRow.containerTypeList.filter(
        (value) => value.id !== containerTypeId
      );
  }

  private showCreateShippingOrderDialog() {
    this.dialogFormVisible = true;
  }

  //页面加载就加载柜型信息
  private async initContainerTypeList() {
    const data: any = await getContainerType();
    this.containerTypeOptionsList = data;
  }

  //新增柜型编辑柜型弹框
  private showOperateDialog(action: string, data: ShippingOrderModel) {
    this.selectedRow = data;
    if (action === "createContainerType") {
      this.containerTypeVisible = true;
    } else if (action === "editContainerType") {
      this.containerTypeVisible = true;
      this.listLoading = false;
    } else if (action === "confirmPutShipping") {
      this.payload = new WriteShippingOrderInput();
      this.confirmPutShippingVisible = true;
    }
    this.dialogStatus = action;
  }

  //新增柜型表单提交
  private containerTypeConfirmed() {
    if (this.dialogStatus === "createContainerType") {
      this.doCreateContainerType();
    } else if (this.dialogStatus === "confirmPutShipping") {
      this.doConfirmPutShipping();
    } else if (this.dialogStatus === "editContainerType") {
      this.doUpdateContainerTypes();
    }
  }

  private async doUpdateContainerTypes() {
    const containerTypes = this.selectedRow.containerTypeList.map((value) => {
      return {
        containerTypeId: value.id,
        containerNumber: value.containerNumber,
        sealNumber: value.sealNumber,
      };
    });
    await updateShippingOrderContainerType(this.selectedRow.id, containerTypes);
    this.containerTypeVisible = false;
    await this.getList();
  }

  private gotoDocumentFlow(data) {
    this.$router.push({
      name: "DocumentFlow",
      params: { type: "SHIPPING_ORDER", documentId: data.id },
    });
  }

  private async doConfirmPutShipping() {
    const { id }: any = await confirmPutShipping(
        this.selectedRow.id,
        this.payload
    );
    this.payload.id = id;
    this.confirmPutShippingVisible = false;
    this.$notify({
      title: "成功",
      message: "创建成功",
      type: "success",
      duration: 2000,
    });
    await this.getList();
  }

  private doCreateContainerType() {
    (this.$refs.containerTypeForm as Form).validate(async (valid) => {
      if (valid) {
        let containerType = { containTypeInfos: this.configuredContainerTypes };
        const { id }: any = await createShippingOrderContainerType(
          this.selectedRow.id,
          containerType
        );
        this.payload.id = id;
        this.containerTypeVisible = false;
        this.$notify({
          title: "成功",
          message: "创建成功",
          type: "success",
          duration: 2000,
        });
        await this.getList();
        this.configuredContainerTypes = [{ id: null, name: null, value: null }];
      }
    });
  }

  private removeContainerType(idx: number) {
    this.configuredContainerTypes = this.configuredContainerTypes.filter(
      (value, index) => index != idx
    );
  }

  private addContainerType() {
    this.configuredContainerTypes.push({ id: null, name: null, value: null });
  }

  private async initSellerList() {
    const data: any = await getUsersByJobPosition(this.JobPositionType.seller);
    this.sellerList = data;
  }

  private totalContainerQuantity = 0;

  @Watch("configuredContainerTypes", { deep: true, immediate: true })
  private calculateTotalContainerQuantity() {
    this.totalContainerQuantity = this.configuredContainerTypes
      .map((value) => value.value)
      .reduce((pre, cur) => pre + Number(cur), 0);
  }

  private selectedRows: IDefaultShippingOrderModel[] = [];

  private onSelectionChange(rows: IDefaultShippingOrderModel[]) {
    this.selectedRows = rows;
  }

  private async onDeleteClick() {
    const ids: string[] = this.selectedRows.map((value) => value.id);
    if (ids.length < 1) {
      Message.error({
        message: "请选择订舱单",
        duration: 2000,
      });
      return;
    }
    await batchDeleteShippingOrders(ids);
    await this.getList();
  }

  private renderCusAbbr(prop, row) {
    if (row.pcName && row.pcName.length > 0){
    return `[${row.pcName}]${prop}`
    }
      return prop
  }
  private curShippingOrderId;
  private  openUpdateRemarkDialog(id: string,remark: string) {
    this.remark = remark;
    this.curShippingOrderId = id;
    this.show_remark = true;
  }

  private showBillLadingCode = false;
  private  openUpdateBillLoadCodeDialog(id: string,billLadingCode: string) {
    this.billLadingCode = billLadingCode;
    this.curShippingOrderId = id;
    this.showBillLadingCode = true;
  }

  private async updateRemark(id:string) {
    await updateRemark(id, this.remark)
    .then(() => {
       this.$notify({
          title: "成功",
          message: "更新备注成功",
          type: "success",
          duration: 2000,
        });
       this.show_remark =false;
       this.getList();
    })
    .catch((err) => {
      console.error(err);
    });
  }

  private async updateBillLadingCode(id:string) {
    await updateBillLadingCode(id, this.billLadingCode)
        .then(() => {
          this.$notify({
            title: "成功",
            message: "更新提单号成功",
            type: "success",
            duration: 2000,
          });
          this.showBillLadingCode =false;
          this.getList();
        })
        .catch((err) => {
          console.error(err);
        });
  }

  private dialogDetailFormVisible = false;
  private detailShippingOrderId = "";
  private detailShippingCode = "";

  private openDetailDialog(row: { id: string; shippingCode: string }) {
    this.detailShippingOrderId = row.id;
    this.detailShippingCode = row.shippingCode || "";
    this.dialogDetailFormVisible = true;
  }
}

class WriteShippingOrderInput {
  id: string; //客户id
  code: string; //客户编号
  name = ""; //BL公司名
  abbreviation = ""; //客户简称
  address = ""; //BL公司地址
  tel = ""; //BL公司其他信息
  nation = ""; //客人国家
  departures = ""; //出口港
  tradeCountry = ""; //贸易国
  departure = ""; //出境关别
  transportation = ""; //运输方式
  destinationCountry = ""; //最终目的国
  deliveryCountry = ""; //运抵国
  portDischarge = ""; //指运港
  internationalTradeTerms = ""; //成交方式
  payment = ""; //付款方式
  paymentDetails = ""; //报关销售合同付款方式
  ladingType = ""; //提单类型
  notifier = ""; //BL通知人公司名
  notifierAddress = ""; //BL通知人地址
  blNotifyPersonInfo = ""; //BL通知人其他信息
  seller: string; //销售员
  customerId: string; //客户
  startDate: Moment; //开始时间
  billLadingCode = ""; //海运提单号
  typeCount: number; // 共计提柜数量
  combinedContainer: boolean; // 是否拼柜
  fivePiecesSetCompanyName: string; //五件套公司名
  fivePiecesSetCompanyAddress: string; //五件套公司地址
  fivePiecesSetCompanyOtherInfo: string; //五件套公司其他信息
  containerTypes: IContainerTypesModel[] = [];
  shippingMark = "";
  company: string;
  fivePiecesSetCompanyNames:[];
  fivePiecesSetCompanyAddresses:[];
  fivePiecesSetCompanyOtherInfos:[];
  blNotifyPersonInfos:[]; //BL通知人公司名
  blNotifiers:[];  //BL通知人地址
  blNotifiersAddress:[]; //BL通知人其他信息
  blCompanyNames:[]; //BL 公司名
  blCompanyAddresses:[]; //BL 公司地址
  blCompanyInfos:[]; // BL 公司其他信息
  ivCompanyNames:[]; // iv 公司其他信息
  ivCompanyAddresses:[];
  ivCompanyInfos:[];
  deliveryCountries:[]; // 运抵国
  destinationCountries:[];// 目标国
  departuresList:[]; // 出口港
  portDischarges:[]; // 指运港
  ladingTypes:[]; // 提单类型
  departureList:[]; // 出境关别
  transportations:[]; // 运输方式
}
